module.exports = "/out/b22ab260da96e9de4391566892274cf6.svg";